import { FreeSpinsInfoEvent, FreeSpinsInfoName, SpinResponse } from '@cgs/data-access';
import { ResponseHolder } from '../response_holder';

export class GameRulesUtils {
  static isFreeSpins(resp: ResponseHolder<SpinResponse>): boolean {
    return !!resp.curResponse.freeSpinsInfo;
  }

  static isFreeSpinsFinishEventSkipped(resp: ResponseHolder<SpinResponse>): boolean {
    return (
      !!resp.preResponse &&
      !!resp.preResponse.freeSpinsInfo &&
      resp.preResponse.freeSpinsInfo.event !== FreeSpinsInfoEvent.FreeSpinsFinished &&
      !resp.curResponse.freeSpinsInfo
    );
  }

  static isFreeSpinsFinishing(resp: ResponseHolder<SpinResponse>): boolean {
    return (
      !!resp.curResponse.freeSpinsInfo &&
      resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsFinished &&
      (resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
        FreeSpinsInfoEvent.FreeFreeSpinsGroupName ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoEvent.PurchasedFreeSpinsGroupName)
    );
  }

  static game59IsFreeSpinsFinishing(resp: ResponseHolder<SpinResponse>): boolean {
    return (
      !!resp.curResponse.freeSpinsInfo &&
      resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsFinished &&
      (resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
        FreeSpinsInfoEvent.FreeFreeSpinsGroupName ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoEvent.PurchasedFreeSpinsGroupName ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoName.FreeRespin ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name === FreeSpinsInfoName.FreeFrozen)
    );
  }

  static isFreeSpinsFinishingWithTypes(resp: ResponseHolder<SpinResponse>): boolean {
    return (
      !!resp.curResponse.freeSpinsInfo &&
      resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsFinished &&
      // TODO: бессмысленные сравнения
      (!!resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoEvent.PurchasedFreeSpinsGroupName ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoName.FreeRespin ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name === FreeSpinsInfoName.FreeFrozen)
    );
  }
}
